import BillTable from "./BillTable";
import Foodtable from "./Foodtable";
import BeverageTable from "./BeverageTable";
import GroupTable from "./GroupTable";

const BillShowTable = ({
  isOrder,
  food,
  beverage,
  foodGroup,
  beverageGroup,
  order,
  totalInfo,
  selected,
  token,
  FoodBeverageSum,
  FoodSale,
  BeverageSale,
  startDate,
  endDate,
  url
}) => {
  return (
    <div className="bill-tables relative">
      <BillTable
        isOrder={isOrder}
        order={order}
        totalInfo={totalInfo}
        selected={selected}
        token={token}
        url={url}
      />
      <div className="food-beverage-table-width">
        <div className="food-beverage-table">
          <Foodtable
            food={food}
            foodGroup={foodGroup}
            FoodBeverageSum={FoodBeverageSum}
            FoodSale={FoodSale}
            outlet={selected}
            startDate={startDate}
            endDate={endDate}
            token={token}
            url={url}
          />
          <BeverageTable
            beverage={beverage}
            beverageGroup={beverageGroup}
            FoodBeverageSum={FoodBeverageSum}
            BeverageSale={BeverageSale}
            outlet={selected}
            startDate={startDate}
            endDate={endDate}
            token={token}
            url={url}
          />
        </div>
      </div>
      <div className="group-table-width">
        <GroupTable Group={foodGroup} title={"Food"} />
        <GroupTable Group={beverageGroup} title={"Beverage"} />
      </div>
    </div>
  );
};

export default BillShowTable;
